import { render, staticRenderFns } from "./Cuenta_x_Pagar.vue?vue&type=template&id=4fffdbbb"
import script from "./Cuenta_x_Pagar.vue?vue&type=script&lang=js"
export * from "./Cuenta_x_Pagar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports